import React from 'react';
import {StyleSheet, View} from 'react-native';
import type {Meta, StoryObj} from '@storybook/react-native-web-vite';

import Text from '../../../themed/Text';

import CreditCardVisual from './CreditCardVisual';

const meta = {
  title: 'Components/Payments/Credit Card Visual',
  component: CreditCardVisual,
  argTypes: {
    cardType: {
      control: 'select',
      options: ['visa', 'mastercard'],
    },
    lastFourDigits: {
      control: 'text',
    },
    expiryMonth: {
      control: 'number',
    },
    expiryYear: {
      control: 'number',
    },
    isEmpty: {
      control: 'boolean',
    },
  },
  decorators: [
    Story => (
      <View style={styles.container}>
        <Story />
      </View>
    ),
  ],
} satisfies Meta<typeof CreditCardVisual>;

export default meta;

type Story = StoryObj<typeof meta>;

export const VisaCard: Story = {
  args: {
    cardType: 'visa',
    lastFourDigits: '4242',
    expiryMonth: 12,
    expiryYear: 2027,
  },
};

export const MastercardCard: Story = {
  args: {
    cardType: 'mastercard',
    lastFourDigits: '8888',
    expiryMonth: 6,
    expiryYear: 2026,
  },
};

export const EmptyCard: Story = {
  args: {
    isEmpty: true,
  },
};

export const ExpiringSoon: Story = {
  args: {
    cardType: 'visa',
    lastFourDigits: '1234',
    expiryMonth: 1,
    expiryYear: 2025,
  },
};

export const AllVariants: Story = {
  render: () => (
    <View style={styles.variantsContainer}>
      <Text style={styles.label}>Visa Card</Text>
      <CreditCardVisual cardType="visa" lastFourDigits="4242" expiryMonth={12} expiryYear={2027} />

      <Text style={styles.label}>Mastercard</Text>
      <CreditCardVisual
        cardType="mastercard"
        lastFourDigits="8888"
        expiryMonth={6}
        expiryYear={2026}
      />

      <Text style={styles.label}>Empty State</Text>
      <CreditCardVisual isEmpty />
    </View>
  ),
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 16,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#F5F5F5',
  },
  variantsContainer: {
    gap: 24,
    alignItems: 'center',
  },
  label: {
    fontSize: 14,
    fontWeight: '600',
    color: '#666',
    marginBottom: 8,
  },
});
